import { POOL } from "../../../../pool";
import axiom from "../../../../utils/axiom";

export const updateDetails = (details) =>
  axiom.patch(POOL.base + POOL.paths.updateDetails, details);
